
import { declareVrunComponent } from '/vodalys/vvuejs/declareVrunComponent.mjs'

import TroubleshootingEncoder from './TroubleshootingEncoder.vue'

declareVrunComponent('troubleshootingEncoder.vrun.component', TroubleshootingEncoder)